var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNochecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.2255,
    height: 5.18689,
    transform: "matrix(0.757783 0.652507 -0.708026 0.706186 3.67383 1)",
    fill: "#FD7272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8416,
    height: 5.21711,
    transform: "matrix(-0.705776 0.708435 -0.759831 -0.650121 18.6738 3.85229)",
    fill: "#FD7272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNochecked);
export default __webpack_public_path__ + "static/media/nochecked.56224a6ba473bf69e5c7e0ac7ef1c81b.svg";
export { ForwardRef as ReactComponent };